import { DataBean } from "../DataBean";

export class Agency extends DataBean {



    public async deleteAgency(idAgency: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAgency_Number", [idAgency]);
    }

    public async getAgencyCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAgencyCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}